import React from "react";
import type { PresenceStatus } from "./usePresence";

const COLORS: Record<PresenceStatus, string> = {
  online: "#16a34a",
  away: "#d97706",
  offline: "#9ca3af",
};
const LABELS: Record<PresenceStatus, string> = {
  online: "online",
  away: "abwesend",
  offline: "offline",
};

/** Kleiner Status-Punkt; nicht nur farbig — trägt aria-label/title (WCAG 1.4.1). */
export const PresenceDot: React.FC<{ status?: PresenceStatus; size?: number }> = ({
  status = "offline",
  size = 10,
}) => (
  <span
    role="img"
    aria-label={LABELS[status]}
    title={LABELS[status]}
    style={{
      display: "inline-block",
      width: size,
      height: size,
      borderRadius: "50%",
      backgroundColor: COLORS[status],
      border: "2px solid #fff",
      boxSizing: "content-box",
      flexShrink: 0,
    }}
  />
);

export default PresenceDot;
